// slideshow
setTimeout(
  function() 
  {
    if($(window).width() < 480) {
      	$('.flickity-viewport').attr('style', 'min-height:250px');
    }
    else if($(window).width() < 720) {
    	$('.flickity-viewport').attr('style', 'min-height:350px');
    }
  }, 500
);


setTimeout(function(){
   var cw = $('a.instagram-photo img').width();
	$('a.instagram-photo img').css({'height':cw+'px'});
}, 1000);


// drawer menu
$( ".header-drawer .navigation a.main-nav-item" ).click(function() {
	if($(window).width() < 1020) {
    	$(this).siblings("ul.secondary").toggle();
    }
});


// quantity update in cart
const pricePerUnit = {
  "flower-day": ['4.00', '4.50', '4.40', '4.30', '4.20', '4.10', '4.00', '4.00'],
  "flower-night": ['4.30', '4.80', '4.70', '4.60', '4.50', '4.40', '4.30', '4.30'],
  "extra-long": ['4.30', '5.00', '4.90', '4.80', '4.70', '4.60', '4.50', '4.40'],
  "product-1": ['3.50', '4.20', '4.10', '4.00', '3.90', '3.80', '3.70', '3.60'],
  "tampon-super": ['3.60', '4.30', '4.20', '4.10', '4.00', '3.90', '3.80', '3.70'],
  "tampon-super-plus": ['3.80', '4.50', '4.40', '4.30', '4.20', '4.10', '4.00', '3.90'],
  "epan-vamvakero-esorouxo-periodou-classic": ['18.00'],
  "epan-vamvakero-esorouxo-periodou-elegant": ['18.00']
}

async function getProductsVariants() {
  const response = await fetch("/products.json");
  const jsonData = await response.json();
  const products = jsonData.products;
  const productVariants = {};
  products.forEach(pr => { productVariants[pr.handle] = pr.variants });

  console.log('productVariants', productVariants)
  return productVariants;
}

async function removeItemFromCart(index) {
  await fetch("/cart/change.js", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line: index,
      quantity: 0,
    }),
  })
}

function addToCart(variantId, qty) {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        'items': [{
          'id': variantId,
          'quantity': qty
        }]
    })
  })
  .then(() => {
    self.location.href = '#cart-table';
    window.location.reload(true);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function disableButtons() {
  $(".cart-item-quantity-minus, .cart-item-quantity-plus").prop('disabled', true);
}

document.addEventListener( 'DOMContentLoaded',  async function () {
  const productsVariants = await getProductsVariants();
  
  $(".cart-item-quantity-minus").click(async function() {
    console.log('minus')
    const qtyEl = $(this).siblings("input[type='text'].cart-item-quantity-display");
    const oldQty = qtyEl.val();
    
    if(!isNaN(oldQty) || oldQty < 0) {
      disableButtons();
      const index = $(this).parents(".cart-item-quantity").data("index");
      const handle = $(this).parents(".cart-item-quantity").data("product-handle");
      const newQty = parseInt(oldQty) - 1;
      // const variantName = pricePerUnit[handle][newQty] || pricePerUnit[handle][0];

      const productId = $(this).closest('.cart-item[data-variant]').attr('data-product-id');
      
      let variantId = $(this).closest('.cart-item[data-variant]').attr('data-variant');
      // if (productId === "14963374653784" || productId === "14932797423960") {
      //   variantId = $(this).closest('.cart-item[data-variant]').attr('data-variant');
      // } else {
      //   variantId = productsVariants[handle].find(variant => variant.title === "ΠΟΣΟΤΗΤΑ / " + variantName + "€ το τεμάχιο").id;
      // }
      
      qtyEl.val(newQty);
      await removeItemFromCart(index);
  
      if(newQty > 0) {
        addToCart(variantId, newQty);
      }
      else {
        self.location.href = '#cart-table';
        window.location.reload(true);
      }
    }
    else {
      alert("Παρακαλώ εισάγετε έναν έγκυρο αριθμό.");
    }
  });

  $(".cart-item-quantity-plus").click(async function() {
    const qtyEl = $(this).siblings("input[type='text'].cart-item-quantity-display");
    const oldQty = qtyEl.val();
    
    if(!isNaN(oldQty) || oldQty < 0) {
      disableButtons();
      const index = $(this).parents(".cart-item-quantity").data("index");
      const handle = $(this).parents(".cart-item-quantity").data("product-handle");
      const newQty = parseInt(oldQty) + 1;
      // const variantName = pricePerUnit[handle][newQty] || pricePerUnit[handle][0];
      
      const productId = $(this).closest('.cart-item[data-variant]').attr('data-product-id');
      let variantId = $(this).closest('.cart-item[data-variant]').attr('data-variant');
      // if (productId === "14963374653784" || productId === "14932797423960") {
      //   variantId = $(this).closest('.cart-item[data-variant]').attr('data-variant');
      // } else {
      //   console.log('productsVariants[handle]', productsVariants[handle][0].id);
      //   variantId = productsVariants[handle].find(variant => variant.title === "ΠΟΣΟΤΗΤΑ / " + variantName + "€ το τεμάχιο").id;
      // }
  
      qtyEl.val(newQty);
      await removeItemFromCart(index);
      addToCart(variantId, newQty);
    }
    else {
      alert("Παρακαλώ εισάγετε έναν έγκυρο αριθμό.");
    }
  });

  $("input[type='text'].cart-item-quantity-display").change(async function() {
    const qty = $(this).val();
    
    if(!isNaN(qty) || qty < 0) {
      disableButtons();
      const index = $(this).parents(".cart-item-quantity").data("index");
      const handle = $(this).parents(".cart-item-quantity").data("product-handle"); 
      // const variantName = pricePerUnit[handle][qty] || pricePerUnit[handle][0];
      //const variantId = productsVariants[handle].find(variant => variant.title === "ΠΟΣΟΤΗΤΑ / " + variantName + "€ το τεμάχιο").id;
      const variantId = $(this).closest('.cart-item[data-variant]').attr('data-variant');
  
      await removeItemFromCart(index);
      addToCart(variantId, qty);
    }
    else {
      alert("Παρακαλώ εισάγετε έναν έγκυρο αριθμό.");
    }
  });

  $(".delete-cart-item-btn").click(async function() {
    const index = $(this).parent().data("index") || $(this).parents(".cart-item-quantity").data("index");
    await removeItemFromCart(index);
    location.reload();
  });
});


